/**
 * 评论表请求接口
 * @author 王振宇
 * @since 2022-06-02
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_MEMBERCOMMENT_PAGE_LIST: function GET_MEMBERCOMMENT_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberComment/getPageList',
        method: 'get',
        params: data
      });
    },
    GET_MEMBERCOMMENT_SUM_COUNT: function GET_MEMBERCOMMENT_SUM_COUNT() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberComment/dataCounts',
        method: 'get',
        params: data
      });
    },
    GET_MEMBERCOMMENT_LIST: function GET_MEMBERCOMMENT_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberComment/getList',
        method: 'get',
        params: data
      });
    },
    GET_MEMBERCOMMENT_INFO: function GET_MEMBERCOMMENT_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberComment/info',
        method: 'get',
        params: data
      });
    },
    SAVE_MEMBERCOMMENT: function SAVE_MEMBERCOMMENT() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberComment/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_MEMBERCOMMENT: function UPDATE_MEMBERCOMMENT() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberComment/update',
        method: 'put',
        data: data
      });
    },
    DELETE_MEMBERCOMMENT: function DELETE_MEMBERCOMMENT() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberComment/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_MEMBERCOMMENT: function DELETE_BATCH_MEMBERCOMMENT() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberComment/deleteBatch',
        method: 'delete',
        data: data
      });
    }
  };
});